import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { MultiStyleType } from '@chakra-ui/styled-system'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { textStyles } from '~/themes/textStyles/defaultTextStyles'
import { getName } from '~/utils/objectUtils'

const {
  FontColor: { Default: DefaultFontColor },
} = themeColorSectionKeys.defaults

const audioSettingsParts = [
  'container',
  'dropdownContainer',
  'text',
  'select',
] as const

const helpers = createMultiStyleConfigHelpers(audioSettingsParts)

export const AudioSettingsStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      width: 'min(400px, fit-content)',
    },
    dropdownContainer: {
      flexDirection: 'column',
      marginBottom: '20px',
      gap: '8px',
    },
    text: {
      ...textStyles[textStyleKeys.Body2],
    },
    select: {
      borderColor: DefaultFontColor,
      color: DefaultFontColor,
      _hover: {
        borderColor: DefaultFontColor,
      },
    },
  },
  defaultProps: {},
})

const audioSettingsKeyName = getName({ AudioSettingsStyle })

export const useAudioSettingsStyles = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(audioSettingsKeyName, props) as MultiStyleType<
    typeof audioSettingsParts
  >
}
